"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _header = _interopRequireDefault(require("../header"));

var _buttonControl = _interopRequireDefault(require("../../preact-components/button-control"));

var _axios = _interopRequireDefault(require("axios"));

var _AlertComponent = _interopRequireDefault(require("@insided/shared/uikit/AlertComponent"));

var _reactModal = _interopRequireDefault(require("../../components/reactModal"));

var _AccordionPanel = _interopRequireDefault(require("../panel/AccordionPanel"));

var _RegistrationApprovalPanel = require("./RegistrationApprovalPanel");

var _UsernameRestrictionsPanel = require("./UsernameRestrictionsPanel");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var RegistrationRules = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(RegistrationRules, _Component);

  var _super = _createSuper(RegistrationRules);

  function RegistrationRules(props) {
    var _this$props$restrictW, _this$props$restricte, _this$props$restrictW2, _this$props$restricte2;

    var _this;

    (0, _classCallCheck2.default)(this, RegistrationRules);
    _this = _super.call(this, props);
    _this.state = {
      storedState: {
        registrationApprovalSetting: _this.props.registrationApprovalSetting,
        restrictPhoneNumberAsUsernameSetting: _this.props.restrictPhoneNumberAsUsernameSetting,
        restrictWordsInUsernameSetting: (_this$props$restrictW = _this.props.restrictWordsInUsernameSetting) !== null && _this$props$restrictW !== void 0 ? _this$props$restrictW : false,
        restrictedWords: (_this$props$restricte = _this.props.restrictedWords) !== null && _this$props$restricte !== void 0 ? _this$props$restricte : undefined
      },
      isRegistrationApprovalEnabled: _this.props.registrationApprovalSetting,
      showRegistrationApprovalActionButtons: false,
      isRestrictPhoneNumberAsUsernameEnabled: _this.props.restrictPhoneNumberAsUsernameSetting,
      isRestrictWordsInUsernameEnabled: (_this$props$restrictW2 = _this.props.restrictWordsInUsernameSetting) !== null && _this$props$restrictW2 !== void 0 ? _this$props$restrictW2 : false,
      restrictedWords: (_this$props$restricte2 = _this.props.restrictedWords) !== null && _this$props$restricte2 !== void 0 ? _this$props$restricte2 : undefined,
      showValidationError: false,
      showUsernameRestrictionsActionButtons: false,
      hasUnsavedChanges: false,
      showUnsavedChangesModal: false
    };
    _this.onRegistrationApprovalChanged = _this.onRegistrationApprovalChanged.bind((0, _assertThisInitialized2.default)(_this));
    _this.saveRegistrationApprovalSetting = _this.saveRegistrationApprovalSetting.bind((0, _assertThisInitialized2.default)(_this));
    _this.resetRegistrationApprovalSettings = _this.resetRegistrationApprovalSettings.bind((0, _assertThisInitialized2.default)(_this));
    _this.onRestrictPhoneNumberAsUsernameSettingChanged = _this.onRestrictPhoneNumberAsUsernameSettingChanged.bind((0, _assertThisInitialized2.default)(_this));
    _this.onRestrictWordsInUsernameSettingChanged = _this.onRestrictWordsInUsernameSettingChanged.bind((0, _assertThisInitialized2.default)(_this));
    _this.onRestrictedWordsChanged = _this.onRestrictedWordsChanged.bind((0, _assertThisInitialized2.default)(_this));
    _this.saveUsernameRestrictionSetting = _this.saveUsernameRestrictionSetting.bind((0, _assertThisInitialized2.default)(_this));
    _this.resetUsernameRestrictionSettings = _this.resetUsernameRestrictionSettings.bind((0, _assertThisInitialized2.default)(_this));
    _this.onFocusRestrictedWords = _this.onFocusRestrictedWords.bind((0, _assertThisInitialized2.default)(_this));
    _this.closeModal = _this.closeModal.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(RegistrationRules, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      window.addEventListener('beforeunload', function (e) {
        return _this2.onUnload(e);
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('beforeunload', this.onUnload);
    }
  }, {
    key: "onUnload",
    value: function onUnload(e) {
      if (this.checkPanelHasUnsavedChanges()) {
        e.preventDefault();
        e.returnValue = '';
      }
    }
  }, {
    key: "onRegistrationApprovalChanged",
    value: function onRegistrationApprovalChanged(value) {
      var showActionButtons = this.state.storedState.registrationApprovalSetting !== value;
      this.setState({
        isRegistrationApprovalEnabled: value,
        showRegistrationApprovalActionButtons: showActionButtons,
        hasUnsavedChanges: showActionButtons,
        activePanel: 1
      });
    }
  }, {
    key: "saveRegistrationApprovalSetting",
    value: function () {
      var _saveRegistrationApprovalSetting = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var successMessage, errorMessage, updatedState;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.setState({
                  messageType: null
                });
                successMessage = "'New registration control' setting has been updated successfully.";
                errorMessage = "Something went wrong, setting can't be updated. Please try again.";
                _context.prev = 3;
                _context.next = 6;
                return _axios.default.post('/user/management/toggleRegistrationApproval', {
                  requireApproval: this.state.isRegistrationApprovalEnabled
                });

              case 6:
                updatedState = this.state.storedState;
                updatedState.registrationApprovalSetting = this.state.isRegistrationApprovalEnabled;
                this.setState({
                  storedState: updatedState,
                  message: successMessage,
                  messageType: 'success',
                  showRegistrationApprovalActionButtons: false
                });
                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](3);
                this.setState({
                  messageType: 'error',
                  message: errorMessage,
                  showRegistrationApprovalActionButtons: false
                });

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 11]]);
      }));

      function saveRegistrationApprovalSetting() {
        return _saveRegistrationApprovalSetting.apply(this, arguments);
      }

      return saveRegistrationApprovalSetting;
    }()
  }, {
    key: "resetRegistrationApprovalSettings",
    value: function resetRegistrationApprovalSettings() {
      this.setState({
        isRegistrationApprovalEnabled: this.state.storedState.registrationApprovalSetting,
        showRegistrationApprovalActionButtons: false
      });
    }
  }, {
    key: "onRestrictPhoneNumberAsUsernameSettingChanged",
    value: function onRestrictPhoneNumberAsUsernameSettingChanged(value) {
      var showActionButtons = this.state.storedState.restrictPhoneNumberAsUsernameSetting !== value;
      this.setState({
        isRestrictPhoneNumberAsUsernameEnabled: value,
        showUsernameRestrictionsActionButtons: showActionButtons,
        hasUnsavedChanges: showActionButtons,
        activePanel: 0
      });
    }
  }, {
    key: "onRestrictWordsInUsernameSettingChanged",
    value: function onRestrictWordsInUsernameSettingChanged(value) {
      var _this$state$storedSta = this.state.storedState,
          restrictWordsInUsernameSetting = _this$state$storedSta.restrictWordsInUsernameSetting,
          restrictedWords = _this$state$storedSta.restrictedWords;
      var showActionButtons = restrictWordsInUsernameSetting !== value || restrictedWords !== this.state.restrictedWords;

      if (!value) {
        this.setState({
          showValidationError: false
        });
      }

      this.setState({
        isRestrictWordsInUsernameEnabled: value,
        showUsernameRestrictionsActionButtons: showActionButtons,
        hasUnsavedChanges: showActionButtons,
        activePanel: 0
      });
    }
  }, {
    key: "onFocusRestrictedWords",
    value: function onFocusRestrictedWords() {
      if (this.state.showUsernameRestrictionsActionButtons) {
        return;
      }

      this.setState({
        showUsernameRestrictionsActionButtons: true
      });
    }
  }, {
    key: "onRestrictedWordsChanged",
    value: function onRestrictedWordsChanged(value) {
      if (value === '') {
        this.setState({
          restrictedWords: [],
          hasUnsavedChanges: true,
          showValidationError: true,
          showUsernameRestrictionsActionButtons: true
        });
        return;
      }

      var words = value.split(',').map(function (word) {
        return word.trim();
      });
      var showActionButtons = this.state.storedState.restrictedWords !== words;
      this.setState({
        restrictedWords: words,
        showUsernameRestrictionsActionButtons: showActionButtons,
        hasUnsavedChanges: showActionButtons,
        showValidationError: false,
        activePanel: 0
      });
    }
  }, {
    key: "saveUsernameRestrictionSetting",
    value: function () {
      var _saveUsernameRestrictionSetting = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var _this$state$restricte;

        var successMessage, errorMessage, updatedState;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(((_this$state$restricte = this.state.restrictedWords) === null || _this$state$restricte === void 0 ? void 0 : _this$state$restricte.length) === 0 && this.state.isRestrictWordsInUsernameEnabled === true)) {
                  _context2.next = 3;
                  break;
                }

                this.setState({
                  showValidationError: true
                });
                return _context2.abrupt("return");

              case 3:
                this.setState({
                  messageType: null
                });
                successMessage = "'Username restriction' settings have been updated successfully.";
                errorMessage = "Something went wrong, settings can't be updated. Please try again.";
                _context2.prev = 6;
                _context2.next = 9;
                return _axios.default.post('/user/management/usernameRestrictionsSetting', {
                  restrictPhoneNumberAsUsername: this.state.isRestrictPhoneNumberAsUsernameEnabled,
                  isRestrictWordsInUsernameEnabled: this.state.isRestrictWordsInUsernameEnabled,
                  restrictedWords: this.state.restrictedWords
                });

              case 9:
                updatedState = this.state.storedState;
                updatedState.restrictedWords = this.state.restrictedWords;
                updatedState.restrictWordsInUsernameSetting = this.state.isRestrictWordsInUsernameEnabled;
                updatedState.restrictPhoneNumberAsUsernameSetting = this.state.isRestrictPhoneNumberAsUsernameEnabled;
                this.setState({
                  message: successMessage,
                  messageType: 'success',
                  showUsernameRestrictionsActionButtons: false,
                  storedState: updatedState
                });
                _context2.next = 19;
                break;

              case 16:
                _context2.prev = 16;
                _context2.t0 = _context2["catch"](6);
                this.setState({
                  messageType: 'error',
                  message: errorMessage,
                  showUsernameRestrictionsActionButtons: false
                });

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[6, 16]]);
      }));

      function saveUsernameRestrictionSetting() {
        return _saveUsernameRestrictionSetting.apply(this, arguments);
      }

      return saveUsernameRestrictionSetting;
    }()
  }, {
    key: "resetUsernameRestrictionSettings",
    value: function resetUsernameRestrictionSettings() {
      var _this$state$storedSta2 = this.state.storedState,
          restrictPhoneNumberAsUsernameSetting = _this$state$storedSta2.restrictPhoneNumberAsUsernameSetting,
          restrictWordsInUsernameSetting = _this$state$storedSta2.restrictWordsInUsernameSetting,
          restrictedWords = _this$state$storedSta2.restrictedWords;
      this.setState({
        isRestrictPhoneNumberAsUsernameEnabled: restrictPhoneNumberAsUsernameSetting,
        isRestrictWordsInUsernameEnabled: restrictWordsInUsernameSetting,
        restrictedWords: restrictedWords,
        showUsernameRestrictionsActionButtons: false,
        showValidationError: false
      });
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      this.setState({
        showUnsavedChangesModal: false
      });
    }
  }, {
    key: "resetChanges",
    value: function resetChanges() {
      var _this$state$storedSta3 = this.state.storedState,
          registrationApprovalSetting = _this$state$storedSta3.registrationApprovalSetting,
          restrictPhoneNumberAsUsernameSetting = _this$state$storedSta3.restrictPhoneNumberAsUsernameSetting,
          restrictWordsInUsernameSetting = _this$state$storedSta3.restrictWordsInUsernameSetting,
          restrictedWords = _this$state$storedSta3.restrictedWords;
      var hasRestrictPhoneNumberAsUsernameChanged = restrictPhoneNumberAsUsernameSetting !== this.state.isRestrictPhoneNumberAsUsernameEnabled;
      var hasRestrictWordsInUsernameChanged = restrictWordsInUsernameSetting !== this.state.isRestrictWordsInUsernameEnabled;
      var hasRestrictWordsListChanged = restrictedWords !== this.state.restrictedWords;
      var usernameRestrictionsChanged = hasRestrictPhoneNumberAsUsernameChanged || hasRestrictWordsInUsernameChanged || hasRestrictWordsListChanged;

      if (usernameRestrictionsChanged) {
        this.setState({
          activePanel: 1
        });
        this.resetUsernameRestrictionSettings();
      }

      if (registrationApprovalSetting !== this.state.isRegistrationApprovalEnabled) {
        this.setState({
          activePanel: 0
        });
        this.resetRegistrationApprovalSettings();
      }

      this.setState({
        hasUnsavedChanges: false,
        showUnsavedChangesModal: false
      });
    }
  }, {
    key: "checkPanelHasUnsavedChanges",
    value: function checkPanelHasUnsavedChanges() {
      var _this$state$storedSta4 = this.state.storedState,
          registrationApprovalSetting = _this$state$storedSta4.registrationApprovalSetting,
          restrictPhoneNumberAsUsernameSetting = _this$state$storedSta4.restrictPhoneNumberAsUsernameSetting,
          restrictWordsInUsernameSetting = _this$state$storedSta4.restrictWordsInUsernameSetting,
          restrictedWords = _this$state$storedSta4.restrictedWords;
      var hasRegistrationApprovalSettingsChanged = registrationApprovalSetting !== this.state.isRegistrationApprovalEnabled;
      var hasRestrictPhoneNumberAsUsernameSettingsChanged = restrictPhoneNumberAsUsernameSetting !== this.state.isRestrictPhoneNumberAsUsernameEnabled;
      var hasRestrictedWordsSettingChanged = restrictWordsInUsernameSetting !== this.state.isRestrictWordsInUsernameEnabled;
      var hasRestrictedWordsChanges = restrictedWords !== this.state.restrictedWords;
      return hasRegistrationApprovalSettingsChanged || hasRestrictPhoneNumberAsUsernameSettingsChanged || hasRestrictedWordsSettingChanged || hasRestrictedWordsChanges;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$state = this.state,
          storedState = _this$state.storedState,
          isRegistrationApprovalEnabled = _this$state.isRegistrationApprovalEnabled,
          showRegistrationApprovalActionButtons = _this$state.showRegistrationApprovalActionButtons,
          isRestrictPhoneNumberAsUsernameEnabled = _this$state.isRestrictPhoneNumberAsUsernameEnabled,
          showUsernameRestrictionsActionButtons = _this$state.showUsernameRestrictionsActionButtons,
          _this$state$isRestric = _this$state.isRestrictWordsInUsernameEnabled,
          isRestrictWordsInUsernameEnabled = _this$state$isRestric === void 0 ? false : _this$state$isRestric,
          restrictedWords = _this$state.restrictedWords,
          showValidationError = _this$state.showValidationError,
          messageType = _this$state.messageType,
          message = _this$state.message,
          showUnsavedChangesModal = _this$state.showUnsavedChangesModal,
          activePanel = _this$state.activePanel;
      var isVisibleFor = messageType === 'success' ? 5000 : false;
      var registrationApprovalStatusText = storedState.registrationApprovalSetting ? 'on' : 'off';
      var usernameRestrictionsStatusText = storedState.restrictPhoneNumberAsUsernameSetting || storedState.restrictWordsInUsernameSetting ? 'on' : 'off';
      var panelHasUnsavedChanges = this.checkPanelHasUnsavedChanges();
      var RegistrationApprovalPanel = {
        title: (0, _preact.h)(_RegistrationApprovalPanel.RegistrationApprovalPanelHeader, {
          statusText: registrationApprovalStatusText
        }),
        body: (0, _preact.h)(_RegistrationApprovalPanel.RegistrationApprovalPanelBody, {
          isRegistrationApprovalEnabled: isRegistrationApprovalEnabled,
          onRegistrationApprovalChanged: function onRegistrationApprovalChanged() {
            return _this3.onRegistrationApprovalChanged(!isRegistrationApprovalEnabled);
          },
          showRegistrationApprovalActionButtons: showRegistrationApprovalActionButtons,
          onSave: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
            return _regenerator.default.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    return _context3.abrupt("return", _this3.saveRegistrationApprovalSetting());

                  case 1:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          })),
          onCancel: function onCancel() {
            return _this3.resetRegistrationApprovalSettings();
          }
        }),
        hasUnsavedChanges: panelHasUnsavedChanges
      };
      var UsernameRestrictionsPanel = {
        title: (0, _preact.h)(_UsernameRestrictionsPanel.UsernameRestrictionsPanelHeader, {
          statusText: usernameRestrictionsStatusText
        }),
        body: (0, _preact.h)(_UsernameRestrictionsPanel.UsernameRestrictionsPanelBody, {
          isRestrictPhoneNumberAsUsernameEnabled: isRestrictPhoneNumberAsUsernameEnabled,
          onRestrictPhoneNumberAsUsernameSettingChanged: function onRestrictPhoneNumberAsUsernameSettingChanged() {
            return _this3.onRestrictPhoneNumberAsUsernameSettingChanged(!isRestrictPhoneNumberAsUsernameEnabled);
          },
          isRestrictWordsInUsernameEnabled: isRestrictWordsInUsernameEnabled,
          onRestrictWordsInUsernameSettingChanged: function onRestrictWordsInUsernameSettingChanged() {
            return _this3.onRestrictWordsInUsernameSettingChanged(!isRestrictWordsInUsernameEnabled);
          },
          restrictedWords: restrictedWords,
          onTextareaFocus: function onTextareaFocus() {
            return _this3.onFocusRestrictedWords();
          },
          onRestrictedWordsChanged: function onRestrictedWordsChanged(value) {
            return _this3.onRestrictedWordsChanged(value.trim());
          },
          showValidationError: showValidationError,
          showUsernameRestrictionsActionButtons: showUsernameRestrictionsActionButtons,
          onSave: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
            return _regenerator.default.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    return _context4.abrupt("return", _this3.saveUsernameRestrictionSetting());

                  case 1:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4);
          })),
          onCancel: function onCancel() {
            return _this3.resetUsernameRestrictionSettings();
          }
        }),
        hasUnsavedChanges: panelHasUnsavedChanges
      };
      return (0, _preact.h)("div", {
        className: "registration-rules-overview qa-registration-rules-overview"
      }, (0, _preact.h)(_header.default, {
        title: "Registration Rules",
        disableCancelButton: true,
        disableSaveButton: true
      }), messageType ? (0, _preact.h)(_AlertComponent.default, {
        messageType: messageType,
        message: message,
        sticky: true,
        renderHTML: true,
        isVisibleFor: isVisibleFor
      }) : null, (0, _preact.h)(_AccordionPanel.default, {
        defaultActivePanelIndex: activePanel,
        panels: [UsernameRestrictionsPanel, RegistrationApprovalPanel],
        renderUnsavedChangesModal: function renderUnsavedChangesModal() {
          return _this3.setState({
            showUnsavedChangesModal: true
          });
        }
      }), (0, _preact.h)(_reactModal.default, {
        isOpen: showUnsavedChangesModal,
        onClose: function onClose() {
          return _this3.closeModal();
        }
      }, (0, _preact.h)("div", {
        className: "unsaved-changes-modal"
      }, (0, _preact.h)("h3", {
        className: "modal-title"
      }, "Unsaved Changes"), (0, _preact.h)("div", {
        className: "modal-description"
      }, "You have unsaved changes. Do you want to discard them?"), (0, _preact.h)(_buttonControl.default, {
        size: "medium",
        variant: "brand",
        newStyle: true,
        title: "Discard changes",
        onClick: function onClick() {
          return _this3.resetChanges();
        }
      }), (0, _preact.h)(_buttonControl.default, {
        newStyle: true,
        size: "medium",
        title: "Cancel",
        onClick: function onClick() {
          return _this3.closeModal();
        }
      }))));
    }
  }]);
  return RegistrationRules;
}(_preact.Component);

var _default = RegistrationRules;
exports.default = _default;